/**
 * Product page tabs (ci-collapsible Accordion / Horizontal Tab Switcher)
 */
(function () {
  function initProductTabs(root) {
    var tabs = root.querySelectorAll('.ci-product-tabs__tab');
    var panels = root.querySelectorAll('.ci-product-tabs__panel');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab-target');

        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
        });
      });
    });
  }

  function isDesktopTabs() {
    return window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
  }

  function closeInner(btn, inner) {
    btn.setAttribute('aria-expanded', 'false');
    inner.style.visibility = 'visible';
    inner.style.height = inner.scrollHeight + 'px';

    requestAnimationFrame(function () {
      inner.style.height = '0px';
    });

    function onCloseEnd(ev) {
      if (ev.propertyName !== 'height') return;
      inner.style.height = '';
      inner.style.visibility = '';
      inner.removeEventListener('transitionend', onCloseEnd);
    }

    inner.addEventListener('transitionend', onCloseEnd);
  }

  function openInner(btn, inner) {
    btn.setAttribute('aria-expanded', 'true');
    inner.style.height = '0px';
    inner.style.visibility = 'visible';

    requestAnimationFrame(function () {
      inner.style.height = inner.scrollHeight + 'px';
    });

    function onOpenEnd(ev) {
      if (ev.propertyName !== 'height' || btn.getAttribute('aria-expanded') !== 'true') return;
      inner.style.height = 'auto';
      inner.removeEventListener('transitionend', onOpenEnd);
    }

    inner.addEventListener('transitionend', onOpenEnd);
  }

  function initCollapsibles() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="toggle-collapsible"]');
      if (!btn) return;
      e.preventDefault();

      var collapsible = btn.closest('.ci-collapsible');
      if (!collapsible) return;

      var inner = collapsible.querySelector('.ci-collapsible__inner');
      if (!inner) return;

      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      var parentTabs = collapsible.closest('.Product__Tabs, .product__tabs');
      var desktop = isDesktopTabs();

      if (parentTabs) {
        parentTabs.querySelectorAll('.ci-collapsible').forEach(function (sibling) {
          if (sibling === collapsible) return;
          var sBtn = sibling.querySelector('.ci-collapsible__button');
          var sInner = sibling.querySelector('.ci-collapsible__inner');
          if (!sBtn || !sInner || sBtn.getAttribute('aria-expanded') !== 'true') return;

          if (!desktop) {
            closeInner(sBtn, sInner);
          } else {
            sBtn.setAttribute('aria-expanded', 'false');
            sInner.style.height = '';
            sInner.style.visibility = '';
          }
        });
      }

      if (desktop) {
        if (isOpen) return;
        btn.setAttribute('aria-expanded', 'true');
        inner.style.height = '';
        inner.style.visibility = '';
        return;
      }

      if (isOpen) {
        closeInner(btn, inner);
      } else {
        openInner(btn, inner);
      }
    });
  }

  document.querySelectorAll('[data-ci-product-tabs]').forEach(initProductTabs);
  initCollapsibles();
})();
